// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 909 ? "motion" : chunkId) + "." + {"196":"707ce260","909":"b1200b53","959":"05ab1bad"}[chunkId] + ".chunk.js";
};